export const auth = {
  welcomeBack: "Welcome back",
  signInHint: "Sign in to your Malfak organization.",
  createAccount: "Create your organization",
  signupHint: "Free to start. Connect Instagram in under a minute.",
  email: "Work email",
  password: "Password",
  name: "Your name",
  orgName: "Business or brand name",
  orgNameHint: "You can invite your team later.",
  showPassword: "Show password",
  hidePassword: "Hide password",
  signIn: "Sign in",
  signingIn: "Signing in…",
  signUp: "Create organization",
  signingUp: "Creating…",
  noAccount: "New to Malfak?",
  haveAccount: "Already have an organization?",
  goSignup: "Create one",
  goLogin: "Sign in",
  badCredentials: "That email and password don't match.",
  emailTaken: "An account with this email already exists.",
  sessionExpired: "Your session ended. Please sign in again.",
  signedOut: "You're signed out.",
  demoHint: "Demo: {{email}} · {{password}}",
  useDemo: "Use demo account",
  passwordRule: "At least 8 characters",
  invalidEmail: "Enter a valid email address",
  required: "Required",
  terms: "By continuing you agree to the Terms and Privacy Policy.",
  heroTitle: "Every comment and DM, answered in your brand's voice",
  heroText: "Malfak brings Instagram comments and messages into one inbox, drafts replies with AI, hides spam on its own and tells you the best time to post.",
  heroBullets: {
    inbox: "One inbox for comments and DMs",
    automation: "Automations you can trust: auto, approve-first or suggest",
    insights: "Analytics and best-time-to-post from your own audience",
    arabic: "Arabic-first, fluent in English",
  },
  heroQuote: "We answer every price question in seconds now, even at 2 a.m.",
  heroQuoteBy: "A Malfak customer, Amman",
  stats: {
    replies: "auto-replies this week",
    saved: "hours saved",
    response: "median response",
  },
  createOrg: {
    title: "Create your organization",
    hint: "Your sign-in isn't part of an organization yet. Name your business or brand to get started.",
    signedInAs: "Signed in as",
    nameHint: "You'll be the owner. You can invite your team later.",
    submit: "Create organization",
    creating: "Creating…",
    trialNote: "New organizations start on a free trial.",
    signOut: "Sign out",
  },
};
